const state = {
	source: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
};

const getters = {
	source: (state): string => state.source as string
};

const actions = {
	check({ dispatch, getters }) {
		const script = document.createElement("script");
		script.src = getters.source;
		document.body.appendChild(script);

		script.onload = () => {
			dispatch("send", 0);
		};

		script.onerror = () => {
			dispatch("send", 1);
		};
	},
	send({ dispatch }, adblock) {
		dispatch(
			"datalayer/push",
			{
				adblock
			},
			{ root: true }
		);
	}
};

export default { namespaced: true, state, actions, getters };
